import { defineStore } from "pinia";
import {
  getBuilderLocationContext,
  getBuilderUrl,
  getRouteParts,
  getRouteUriFromLocation,
  readSidebarWidth,
  updateHistory,
} from "~/helpers/builder-navigation-helper";

export const SIDEBAR_MIN_WIDTH = 310;
export const SIDEBAR_DEFAULT_WIDTH = 343;
export const SIDEBAR_MAX_WIDTH = 800;

const SIDEBAR_WIDTH_STORAGE_KEY = "builder-navigation-sidebar-width";

export const useBuilderNavigationStore = defineStore("builder-navigation-store", {
  state: () => {
    const locationPathname = typeof window === "undefined" ? "/" : window.location.pathname;
    const route = getRouteParts(getRouteUriFromLocation());

    return {
      locationPathname,
      page: route.page,
      section: route.section,
      subPage: route.subPage,
      sidebarWidth: readSidebarWidth(SIDEBAR_WIDTH_STORAGE_KEY, SIDEBAR_DEFAULT_WIDTH),
      menuItems: [],
    };
  },
  getters: {
    locationContext() {
      return getBuilderLocationContext(this.locationPathname);
    },
    currentUri() {
      if (this.section === "users" && this.page === "users") {
        if (!this.subPage) {
          return "/users";
        }

        if (["applications", "invites", "invite"].includes(this.subPage)) {
          return `/users/${this.subPage}`;
        }
      }

      const parts = [this.section, this.page, this.subPage].filter(Boolean);
      return parts.length ? `/${parts.join("/")}` : "/";
    },
  },
  actions: {
    getUrl(uri, value = null) {
      if (!uri || uri[0] !== "/") {
        throw new Error("Uri must start with a slash");
      }

      if (this.locationContext.kind === "none") {
        return null;
      }

      return getBuilderUrl(this.locationContext.rootPath, uri, value);
    },
    syncFromLocation() {
      this.locationPathname = typeof window === "undefined" ? "/" : window.location.pathname;

      const route = getRouteParts(getRouteUriFromLocation(this.locationPathname));

      this.section = route.section;
      this.page = route.page;
      this.subPage = route.subPage;
    },
    navigateToUri(uri, options = {}) {
      if (!uri || uri[0] !== "/") {
        throw new Error("Uri must start with a slash");
      }

      updateHistory(uri, {
        replaceHistory: Boolean(options.replaceHistory),
      });

      this.syncFromLocation();
    },
    setMenuItems(menuItems) {
      this.menuItems = Array.isArray(menuItems) ? menuItems : [];
    },
    setSidebarWidth(width) {
      let nextWidth = width;

      if (nextWidth > SIDEBAR_MAX_WIDTH) {
        nextWidth = SIDEBAR_MAX_WIDTH;
      }

      if (nextWidth < SIDEBAR_MIN_WIDTH) {
        nextWidth = SIDEBAR_MIN_WIDTH;
      }

      this.sidebarWidth = nextWidth;

      if (typeof window === "undefined") {
        return;
      }

      window.localStorage.setItem(SIDEBAR_WIDTH_STORAGE_KEY, `${nextWidth}`);
    },
  },
});
